
<div class="card" style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;">
    <div class="card-header card-header-primary">
      <div class="row">
          <div class="col-sm-12 col-md-10">
            <h4 class="card-title">
                <i class="material-icons">person_add</i>
              <b style="margin-left: 25px">Modificación Tiempo Prioridad </b></h4>
        </div>
          <div class="col-sm-12 col-md-2">
              <button mat-icon-button   (click)="back()">
                <mat-icon  style="font-size: 35px">clear</mat-icon>
              </button>
        </div>
   </div>
  </div>
  
  <div class="card-body">
      <div class="row ">
        <div class="col-sm-4">
            <mat-form-field class="example-full-width" >
                <input matInput placeholder="Nombre de Prioridad" aria-label="Nombre de Prioridad" type="text" [(ngModel)]="prioridad.nombre" readonly>
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <mat-form-field class="example-full-width" >
                <input matInput placeholder="Tiempo en Horas" aria-label="Tiempo en Horas" type="text" [(ngModel)]="prioridad.tiempo_en_horas" soloNumeroEntero maxlength='2'>
            </mat-form-field>
        </div>
      </div>

    </div>
    <mat-card-actions >
        <div class="col-sm-6 ml-auto mr-auto">
          <button mat-button class="btn btn-danger" (click)="back()">Cancelar</button>
          <button mat-button class="btn btn-success" (click)="guardarActualizar()">Guardar</button>
        </div>
      </mat-card-actions>
</div>
  